/*
 * @Description: 
 * @Author: yingbin
 * @Date: 2019-08-23 15:27:05
 * @LastEditTime: 2019-09-03 11:10:39
 * @LastEditors: yingbin
 */
export default {
    // doTest:state=>{
    //     return state.test=30
    // }
}